import { gql } from '@apollo/client';

const paginationCalendarLightEventQuery = gql`
  query paginationCalendarLightEventQuery(
    $filter: FilterPaginationCalendarEventLightInput
    $page: Int
    $perPage: Int
  ) {
    paginationCalendarLightEventQuery(filter: $filter, page: $page, perPage: $perPage) {
      items {
        _id
        title
        dateTime
        color
        status
        creator
        notesAboutStudent
        data {
          course
          courseCategory
          lesson
          studentsGroup
          eventType
        }
      }
      pageInfo {
        currentPage
        perPage
        hasNextPage
      }
    }
  }
`;

export default paginationCalendarLightEventQuery;
